export type LocationOption = {
  id: string;
  display_name: string;
};

export const normalizeLocationIds = (value: unknown): string[] | null => {
  if (!Array.isArray(value)) return null;
  const ids = value
    .filter((id): id is string => typeof id === "string")
    .map((id) => id.trim())
    .filter(Boolean);
  return ids;
};

export const filterLocationsByAllowedLocationIds = (
  locations: LocationOption[],
  allowedLocationIds: string[] | null | undefined,
): LocationOption[] => {
  if (!Array.isArray(allowedLocationIds)) return locations;
  const allowedSet = new Set(allowedLocationIds);
  return locations.filter((location) => allowedSet.has(location.id));
};

export const coerceLocationSelectionToAllowedLocationIds = (
  selectedLocationIds: string[] | null,
  allowedLocationIds: string[] | null,
): string[] | null => {
  if (!Array.isArray(allowedLocationIds)) return selectedLocationIds;
  if (allowedLocationIds.length === 0) return null;
  if (!Array.isArray(selectedLocationIds) || selectedLocationIds.length === 0) return null;

  const allowedSet = new Set(allowedLocationIds);
  const filtered = selectedLocationIds.filter((id) => allowedSet.has(id));
  if (filtered.length > 0) return filtered;

  return [allowedLocationIds[0]];
};
